function objectToUrl(obj: ReadOnlyKeyPairString): string {
  return Object.entries(obj)
    .map(arr => arr.join('='))
    .join('&')
}

export default objectToUrl
